
export type SubCheck = {
  status: "Healthy" | "Degraded" | "Unhealthy";
  description: string | null;
};

export type HealthCheckResponse = {
  version: string;
  status: "Healthy" | "Degraded" | "Unhealthy";
  results: {
    [check: string]: SubCheck;
  };
};

// Status to color mapping
export const STATUS_COLORS: Record<HealthCheckResponse["status"], string> = {
  Healthy: "var(--success-bg)",
  Degraded: "var(--color-warning)",
  Unhealthy: "var(--color-error)",
};

export const checkNameMap: Record<string, string> = {
  PrerequisitesHealthCheck: "Prerequisites",
  GroupGenerationHealthCheck: "Group Generation",
  UpgradeHealthCheck: "Upgrade",
  DiskHealthCheck: "Disk",
  DatabaseHealthCheck: "Database",
  ActivityHealthCheck: "Activity",
  LogHealthCheck: "Log",
  DeviceGenerationHealthCheck: "Device Generation",
  PTToXHealthCheck: "PTToX",
  OTAPAgentHealthCheck: "OTAP Agent",
  BackgroundTaskHealthCheck: "Background Task",
  HangfireServerHealthCheck: "Hangfire Server",
};